import { ListItemButtonProps } from '@mui/material';
import React from 'react';
import { ContactListItemRoot, UnreadIndicator } from './ContactListItem.styles';

type ContactListItemProps = ListItemButtonProps & { unread?: boolean };

export const ContactListItem = ({ unread = false, children, ...props }: ContactListItemProps) => (
  <ContactListItemRoot {...props}>
    {unread && <UnreadIndicator color="success" aria-label="Unread" />}
    {children}
  </ContactListItemRoot>
);
